import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	documentTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pageHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	learnMore: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	documentTitle: {
		id: 'reports-overview-page.document-title',
		defaultMessage: 'Reports',
		description: 'Document title for the Reports overview page.',
	},
	pageHeader: {
		id: 'reports-overview-page.page-header',
		defaultMessage: 'All reports',
		description: 'Heading for the Reports overview page.',
	},
	learnMore: {
		id: 'software-reports.overview.list.item.learn-more',
		defaultMessage: 'Learn more',
		description:
			'Learn more hyperlink takes users to a page guiding them through setting up CI/CD pipelines.',
	},
});
export default messages;
